import script from "./Denglu.vue?vue&type=script&setup=true&lang=js"
export * from "./Denglu.vue?vue&type=script&setup=true&lang=js"

import "./Denglu.vue?vue&type=style&index=0&id=32d4696e&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d4696e"]])

export default __exports__